module.exports = __webpack_public_path__ + "img/lens-150-plus-03.11aa2c37.png";